import pitch from "../assets/pitch.jpg"
import dash from "../assets/dash.png"
import nlb from "../assets/nlb.jpg"

const ProjectCardData = [
    {
        imgsrc: pitch,
        title: "Pitch Predictor",
        text: "Quickly predict what pitch your favorite MLB pitcher will throw in a given game situation using machine learning and data analysis! \n Available on the iOS App Store by searching up \"Pitch Predictor\".",
        tech: "Used Swift, Xcode, Python, Streamlit, Scikit-Learn, and CreateML.",
        view: "https://apps.apple.com/cd/app/pitch-predictor/id1639713170"
    },
    {
        imgsrc: nlb,
        title: "NLB - Nothing Left Behind",
        text: "Winning 3rd overall at HackUTD 2025, NLB is a shared grocery shopping list for roommates and families, sending location based reminders to pickup nearby items. \n Available on the iOS App Store by searching up \"NLB - Nothing Left Behind\".",
        tech: "Used Swift, Xcode, OCR, Apple Mapkit, Gemini API, and Firebase.",
        view: "https://apps.apple.com/us/app/nlb-nothing-left-behind/id6756280239"
    },
    {
        imgsrc: dash,
        title: "Dash",
        text: "Winning 2nd overall at HackUTA 2025, Dash is an AI-powered driver monitoring system that uses Arduino sensors and computer vision to detect distracted driving in real-time.",
        tech: "Used Python, OpenCV, Arduino, React, Supabase, PyTorch, Nvidia AgentIQ, and other libraries.",
        view: "https://devpost.com/software/tbd-3kf6mh"
    }
];

export default ProjectCardData;